















































import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, PropSync } from 'vue-property-decorator'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Card from '@/modules/shared/components/shared/Card.vue'
import RadioCard from '@/modules/shared/components/shared/kit/RadioCard.vue'
import { CampaignItemPaymentType } from '@/modules/campaign-item-payment/models/campaign-item-payment-resource.model'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'

@Component({
  components: {
    Toggle,
    RadioCard,
    Card,
    BaseInput,
    Modal,
    BaseButton
  }
})
export default class CampaignItemPaymentMethods extends Vue {

  @Prop({ required: true }) paymentTypes!: { [key in CampaignItemPaymentType]: string }

  @PropSync('paymentMethodData', {
    required: true
  }) paymentMethod!: string

  private PaymentTypes = CampaignItemPaymentType

  methodIsAvailable(method: string) {
    return this.paymentTypes.hasOwnProperty(method)
  }

}
